import { render, staticRenderFns } from "./BannerGraphic.vue?vue&type=template&id=46d8f4c2&"
import script from "./BannerGraphic.vue?vue&type=script&lang=js&"
export * from "./BannerGraphic.vue?vue&type=script&lang=js&"
import style0 from "./BannerGraphic.vue?vue&type=style&index=0&id=46d8f4c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports